// composables/swatches/roastNameMapper.js

export const normalizeVariantName = (name = "") => {
  const trimmed = name.trim()
  if (trimmed === "Beans") {
    return "Whole Beans"
  }
  return trimmed
}

export const extractShortRoastName = (fullName = "") => {
  const nameLower = fullName.toLowerCase()

  // Decaf variations
  if (nameLower.includes("decaf") && nameLower.includes("medium")) {
    return "Decaf Medium"
  }
  if (nameLower.includes("decaf") && nameLower.includes("dark")) {
    return "Decaf Dark"
  }

  // Standard roasts
  if (nameLower.includes("light")) {
    return "Light"
  }
  if (nameLower.includes("medium")) {
    return "Medium"
  }
  if (nameLower.includes("dark")) {
    return "Dark"
  }

  // Flavored coffees
  if (nameLower.includes("pistachio") && nameLower.includes("decaf")) {
    return "Pistachio Decaf"
  }
  if (nameLower.includes("pistachio")) {
    return "Pistachio"
  }
  if (nameLower.includes("caramel macchiato")) {
    return "Caramel Macchiato"
  }
  if (nameLower.includes("espresso")) {
    return "Espresso"
  }
  if (nameLower.includes("french vanilla")) {
    return "French Vanilla"
  }
  if (nameLower.includes("hazelnut")) {
    return "Hazelnut"
  }

  return fullName.trim()
}

